import React from "react";
import { 
  Grid, 
  Box, 
  Stack, 
  Button, 
  Text, 
  Icon, 
  Divider 
} from "@chakra-ui/react";
import { 
  FaClipboardList, 
  FaChartLine, 
  FaRobot, 
  FaCalendarAlt 
} from "react-icons/fa";
import LibraryAnalysesComponent from "../../components/library/LibraryAnalysesComponent";
import LibraryPlansComponent from "../../components/library/LibraryPlansComponent";
import LibraryAgentsComponent from "../../components/library/LibraryAgentsComponent";
import LibrarySchedulesComponent from "../../components/library/LibrarySchedulesComponent";

interface LibraryNavigationProps {
  activeSection: string;
  setActiveSection: (section: string) => void;
}

const LibraryNavigationPage: React.FC<LibraryNavigationProps> = ({ activeSection, setActiveSection }) => {

  const handleAnalysesClick = () => {
    setActiveSection("analyses");
  };

  const handlePlansClick = () => {
    setActiveSection("plans");
  };

  const handleAgentsClick = () => {
    setActiveSection("agents");
  };

  const handleSchedulesClick = () => {
    setActiveSection("schedules");
  };

  return(
    <Grid height="100%" templateColumns="1fr 4fr" gap={1}>
      {/* Navigation Sidebar */}
      <Box bg="bg.surface" boxShadow="lg" borderRadius="lg" overflowY="hidden">
        <Box
          borderColor="#4e1e6c"
          height="100%"
          display="flex"
          flexDirection="column"
        >
          <Box bg="bg.surface" p={2} height="100%">
            <Text
              fontWeight="bold"
              align="left"
              m={1}
              color="fg.muted"
              fontSize="sm"
            >
              Navigation
            </Text>
            <Divider m={1} />
            <Stack
              height="96%"
              spacing="1"
              alignItems="left"
              overflowY="auto"
              sx={{
                "::-webkit-scrollbar": { width: "4px" },
                "::-webkit-scrollbar-track": { background: "gray.100" },
                "::-webkit-scrollbar-thumb": { 
                  background: "gray.500", 
                  borderRadius: "8px" 
                },
                "::-webkit-scrollbar-thumb:hover": { background: "gray.600" },
                scrollbarWidth: "thin",
                scrollbarColor: "gray.500 gray.100",
              }}
            >
              <Button
                variant="tertiary"
                justifyContent="start"
                iconSpacing="3"
                leftIcon={<Icon as={FaClipboardList} boxSize="1.2rem" />}
                _hover={{ bg: "purple.100", color: "black" }}
                bg={activeSection === "plans" ? "purple.600" : "white"}
                color={activeSection === "plans" ? "white" : "fg.default"}
                borderRadius="lg"
                py={2}
                onClick={handlePlansClick}
                cursor="pointer"
              >
                <Text fontSize="sm" fontWeight="medium" align="left" m={0}>
                  Plans
                </Text>
              </Button>

              <Button
                variant="tertiary"
                justifyContent="start"
                iconSpacing="3"
                leftIcon={<Icon as={FaChartLine} boxSize="1.2rem" />}
                _hover={{ bg: "purple.100", color: "black" }}
                bg={activeSection === "analyses" ? "purple.600" : "white"}
                color={activeSection === "analyses" ? "white" : "fg.default"}
                borderRadius="lg"
                py={2}
                onClick={handleAnalysesClick}
                cursor="pointer"
              >
                <Text fontSize="sm" fontWeight="medium" align="left" m={0}>
                  Analyses
                </Text>
              </Button>

              <Button
                variant="tertiary"
                justifyContent="start"
                iconSpacing="3"
                leftIcon={<Icon as={FaRobot} boxSize="1.2rem" />}
                _hover={{ bg: "purple.100", color: "black" }}
                bg={activeSection === "agents" ? "purple.600" : "white"}
                color={activeSection === "agents" ? "white" : "fg.default"}
                borderRadius="lg"
                py={2}
                onClick={handleAgentsClick}
                cursor="pointer"
              >
                <Text fontSize="sm" fontWeight="medium" align="left" m={0}>
                  Agents
                </Text>
              </Button>

              <Button
                variant="tertiary"
                justifyContent="start"
                iconSpacing="3"
                leftIcon={<Icon as={FaCalendarAlt} boxSize="1.2rem" />}
                _hover={{ bg: "purple.100", color: "black" }}
                bg={activeSection === "schedules" ? "purple.600" : "white"}
                color={activeSection === "schedules" ? "white" : "fg.default"}
                borderRadius="lg"
                py={2}
                onClick={handleSchedulesClick}
                cursor="pointer"
              >
                <Text fontSize="sm" fontWeight="medium" align="left" m={0}>
                  Schedules
                </Text>
              </Button>
            </Stack>
          </Box>
        </Box>
      </Box>

      {/* Main Content Area */}
      <Box bg="bg.surface" boxShadow="lg" borderRadius="lg" overflowY="auto">
        {activeSection === "analyses" && <LibraryAnalysesComponent />}
        {activeSection === "plans" && <LibraryPlansComponent />}
        {activeSection === "agents" && <LibraryAgentsComponent />}
        {activeSection === "schedules" && <LibrarySchedulesComponent />}
      </Box>
    </Grid>
  );
};

export default LibraryNavigationPage;